import React from "react";
import { logoutUser } from "slices/thunk";
import { Navigate, useNavigate } from "react-router-dom";
import { AppDispatch } from "slices/store";
import { useAppDispatch, useAppSelector } from "slices/hook";
import { getAuthState } from "slices/auth/login/reducer";
import LoadingComponent from "common/components/loader";
import { RoutePath } from "routes/route-path";

const Logout: React.FC = () => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useAppDispatch();
  const { loading, loggedInuser } = useAppSelector(getAuthState);

  React.useEffect(() => {
    dispatch(logoutUser());
  }, []);

  React.useEffect(() => {
    if (!loggedInuser?.id) {
      navigate(RoutePath.Login_page);
    }
  }, [loggedInuser]);

  return <LoadingComponent />;
  /* 

  interface selectLogoutState {
  isUserLogout: boolean;
}

    const dispatch = useDispatch<any>();

    const selectLogout = createSelector(
        (state: RootState) => state.user as selectLogoutState,
        (login) => ({
            isUserLogout: login.isUserLogout
        })
    );

    const { isUserLogout } = useSelector(selectLogout); 

    React.useEffect(() => {
        dispatch(logoutUser());
    }, [dispatch]);

    return isUserLogout ? <Navigate to="/login" /> : null;*/
};

export default Logout;
